import { StatusTagColor } from "../components/Account/StatusTag";
import { RequestStatus } from "../firestore/Types/RequestSchema";

export function getStatusColor(status: RequestStatus): StatusTagColor {
    switch (status) {
        case RequestStatus.Approved:
            return StatusTagColor.Green;
        case RequestStatus.Pending:
            return StatusTagColor.Yellow;
        case RequestStatus.Rejected:
            return StatusTagColor.Red;
        default:
            return StatusTagColor.Red;
    }
}

export function getStatusText(status: RequestStatus): string {
    switch (status) {
        case RequestStatus.Approved:
            return "Approved";
        case RequestStatus.Pending:
            return "Pending";
        case RequestStatus.Rejected:
            return "Rejected";
        default:
            return "None";
    }
}